import React, { useState, useEffect } from 'react';
import { Typography, Button, CircularProgress } from '@mui/material';
import { useTeamsTeamsDestroyMutation } from '../../../../services/GLOWClient';
import MuiDialog from '../../../../SystemDesign/MuiDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import theme from '../../../../theme';

const DeleteTeam = ({ open, onClose, onSuccess, team }) => {
    const [dialogClosed, setDialogClosed] = useState(false);
    const [deleteTeam, { isLoading: isDeleting }] = useTeamsTeamsDestroyMutation();
    
    // Reset dialog state when open/close changes
    useEffect(() => {
        if (open === false) {
            setDialogClosed(true);
        } else {
            setDialogClosed(false);
        }
    }, [open]);
    
    const handleDelete = async () => {
        if (!team || !team.id) {
            console.error('No team selected for deletion');
            return;
        }
        
        try {
            // Use the team ID directly as required by the API
            await deleteTeam({ teamId: team.id }).unwrap();
            
            // Call success callback and close dialog
            onSuccess && onSuccess();
            onClose();
        } catch (error) {
            console.error('Failed to delete team:', error);
        }
    };
    
    // Content to be displayed in the dialog
    const confirmationContent = (
        <div style={{ padding: '16px 0' }}>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
                Êtes-vous sûr de vouloir supprimer le groupe <strong>{team?.name}</strong>?
            </Typography>
            <Typography variant="body2" color="error" style={{ marginTop: '8px' }}>
                Cette action est irréversible et supprimera toutes les données associées à ce groupe.
            </Typography>
        </div>
    );

    // Trigger button for the dialog - this is hidden as we're controlling the dialog externally
    const triggerButton = <Button style={{ display: 'none' }}>Open</Button>;

    return (
        <MuiDialog
            open={open}
            icon={<DeleteIcon />}
            triggerButton={triggerButton}
            title="Supprimer le groupe"
            subtitle={`Supprimer définitivement le groupe ${team?.name || ''}`}
            content={confirmationContent}
            existAction={true}
            actionTitle="Supprimer"
            actionFunction={handleDelete}
            onClose={dialogClosed}
            onExternalClose={onClose}
            isLoading={isDeleting}
            actionType="button"
            maxWidth="sm"
            disableAction={isDeleting}
        />
    );
};

export default DeleteTeam;